function getEvents(pageId) {
  if (
    process.env.STORYBOOK_DISABLE_ANIMATIONS === "1" ||
    process.env.STORYBOOK_DISABLE_ANIMATIONS
  ) {
    return {};
  }
  return {
    events: {
      e: {
        id: "e",
        name: "",
        animationType: "preset",
        eventTypeId: "SCROLL_INTO_VIEW",
        action: {
          id: "",
          actionTypeId: "GENERAL_START_ACTION",
          config: {
            delay: 0,
            easing: "",
            duration: 0,
            actionListId: "a-2",
            affectedElements: {},
            playInReverse: false,
            autoStopEventId: "e-2175",
          },
        },
        mediaQueries: ["main", "medium", "small", "tiny"],
        target: {
          id: `${pageId}|1acb1df5-4f62-72c8-ccf1-49c8e1a23f1e`,
          appliesTo: "ELEMENT",
          styleBlockIds: [],
        },
        targets: [
          {
            id: `${pageId}|1acb1df5-4f62-72c8-ccf1-49c8e1a23f1e`,
            appliesTo: "ELEMENT",
            styleBlockIds: [],
          },
        ],
        config: {
          loop: false,
          playInReverse: false,
          scrollOffsetValue: 50,
          scrollOffsetUnit: "%",
          delay: null,
          direction: null,
          effectIn: null,
        },
        createdOn: 1632896084182,
      },
      "e-2": {
        id: "e-2",
        name: "",
        animationType: "custom",
        eventTypeId: "SCROLLING_IN_VIEW",
        action: {
          id: "",
          actionTypeId: "GENERAL_CONTINUOUS_ACTION",
          config: { actionListId: "a", affectedElements: {}, duration: 0 },
        },
        mediaQueries: ["main", "medium", "small", "tiny"],
        target: {
          id: `${pageId}|1acb1df5-4f62-72c8-ccf1-49c8e1a23efa`,
          appliesTo: "ELEMENT",
          styleBlockIds: [],
        },
        targets: [
          {
            id: `${pageId}|1acb1df5-4f62-72c8-ccf1-49c8e1a23efa`,
            appliesTo: "ELEMENT",
            styleBlockIds: [],
          },
        ],
        config: [
          {
            continuousParameterGroupId: "a-p",
            smoothing: 50,
            startsEntering: true,
            addStartOffset: false,
            addOffsetValue: 50,
            startsExiting: false,
            addEndOffset: false,
            endOffsetValue: 50,
          },
        ],
        createdOn: 1626860473655,
      },
      "e-3": {
        id: "e-3",
        name: "",
        animationType: "preset",
        eventTypeId: "SCROLL_OUT_OF_VIEW",
        action: {
          id: "",
          actionTypeId: "GENERAL_START_ACTION",
          config: {
            delay: 0,
            easing: "",
            duration: 0,
            actionListId: "a-3",
            affectedElements: {},
            playInReverse: false,
            autoStopEventId: "e-1931",
          },
        },
        mediaQueries: ["main", "medium", "small", "tiny"],
        target: {
          id: `${pageId}|1acb1df5-4f62-72c8-ccf1-49c8e1a23f08`,
          appliesTo: "ELEMENT",
          styleBlockIds: [],
        },
        targets: [
          {
            id: `${pageId}|1acb1df5-4f62-72c8-ccf1-49c8e1a23f08`,
            appliesTo: "ELEMENT",
            styleBlockIds: [],
          },
        ],
        config: {
          loop: false,
          playInReverse: false,
          scrollOffsetValue: 50,
          scrollOffsetUnit: "%",
          delay: null,
          direction: null,
          effectIn: null,
        },
        createdOn: 1632896086207,
      },
      "e-4": {
        id: "e-4",
        name: "",
        animationType: "custom",
        eventTypeId: "SCROLL_INTO_VIEW",
        action: {
          id: "",
          actionTypeId: "GENERAL_START_ACTION",
          config: {
            delay: 0,
            easing: "",
            duration: 0,
            actionListId: "a-2",
            affectedElements: {},
            playInReverse: false,
            autoStopEventId: "e-1928",
          },
        },
        mediaQueries: ["main", "medium", "small", "tiny"],
        target: {
          id: `${pageId}|1acb1df5-4f62-72c8-ccf1-49c8e1a23efd`,
          appliesTo: "ELEMENT",
          styleBlockIds: [],
        },
        targets: [
          {
            id: `${pageId}|1acb1df5-4f62-72c8-ccf1-49c8e1a23efd`,
            appliesTo: "ELEMENT",
            styleBlockIds: [],
          },
        ],
        config: {
          loop: false,
          playInReverse: false,
          scrollOffsetValue: 50,
          scrollOffsetUnit: "%",
          delay: null,
          direction: null,
          effectIn: null,
        },
        createdOn: 1626765977818,
      },
      "e-5": {
        id: "e-5",
        name: "",
        animationType: "custom",
        eventTypeId: "SCROLL_OUT_OF_VIEW",
        action: {
          id: "",
          actionTypeId: "GENERAL_START_ACTION",
          config: {
            delay: 0,
            easing: "",
            duration: 0,
            actionListId: "a-3",
            affectedElements: {},
            playInReverse: false,
            autoStopEventId: "e-2568",
          },
        },
        mediaQueries: ["main", "medium", "small", "tiny"],
        target: {
          id: `${pageId}|1acb1df5-4f62-72c8-ccf1-49c8e1a23efd`,
          appliesTo: "ELEMENT",
          styleBlockIds: [],
        },
        targets: [
          {
            id: `${pageId}|1acb1df5-4f62-72c8-ccf1-49c8e1a23efd`,
            appliesTo: "ELEMENT",
            styleBlockIds: [],
          },
        ],
        config: {
          loop: false,
          playInReverse: false,
          scrollOffsetValue: 50,
          scrollOffsetUnit: "%",
          delay: null,
          direction: null,
          effectIn: null,
        },
        createdOn: 1626765977820,
      },
      "e-6": {
        id: "e-6",
        name: "",
        animationType: "preset",
        eventTypeId: "SCROLL_INTO_VIEW",
        action: {
          id: "",
          actionTypeId: "GENERAL_START_ACTION",
          config: {
            delay: 0,
            easing: "",
            duration: 0,
            actionListId: "a-2",
            affectedElements: {},
            playInReverse: false,
            autoStopEventId: "e-1417",
          },
        },
        mediaQueries: ["main", "medium", "small", "tiny"],
        target: {
          id: `${pageId}|1acb1df5-4f62-72c8-ccf1-49c8e1a23f13`,
          appliesTo: "ELEMENT",
          styleBlockIds: [],
        },
        targets: [
          {
            id: `${pageId}|1acb1df5-4f62-72c8-ccf1-49c8e1a23f13`,
            appliesTo: "ELEMENT",
            styleBlockIds: [],
          },
        ],
        config: {
          loop: false,
          playInReverse: false,
          scrollOffsetValue: 50,
          scrollOffsetUnit: "%",
          delay: null,
          direction: null,
          effectIn: null,
        },
        createdOn: 1632896085178,
      },
      "e-7": {
        id: "e-7",
        name: "",
        animationType: "preset",
        eventTypeId: "SCROLL_INTO_VIEW",
        action: {
          id: "",
          actionTypeId: "GENERAL_START_ACTION",
          config: {
            delay: 0,
            easing: "",
            duration: 0,
            actionListId: "a-2",
            affectedElements: {},
            playInReverse: false,
            autoStopEventId: "e-532",
          },
        },
        mediaQueries: ["main", "medium", "small", "tiny"],
        target: {
          id: `${pageId}|1acb1df5-4f62-72c8-ccf1-49c8e1a23f08`,
          appliesTo: "ELEMENT",
          styleBlockIds: [],
        },
        targets: [
          {
            id: `${pageId}|1acb1df5-4f62-72c8-ccf1-49c8e1a23f08`,
            appliesTo: "ELEMENT",
            styleBlockIds: [],
          },
        ],
        config: {
          loop: false,
          playInReverse: false,
          scrollOffsetValue: 50,
          scrollOffsetUnit: "%",
          delay: null,
          direction: null,
          effectIn: null,
        },
        createdOn: 1632896086207,
      },
      "e-8": {
        id: "e-8",
        name: "",
        animationType: "preset",
        eventTypeId: "SCROLL_OUT_OF_VIEW",
        action: {
          id: "",
          actionTypeId: "GENERAL_START_ACTION",
          config: {
            delay: 0,
            easing: "",
            duration: 0,
            actionListId: "a-3",
            affectedElements: {},
            playInReverse: false,
            autoStopEventId: "e-587",
          },
        },
        mediaQueries: ["main", "medium", "small", "tiny"],
        target: {
          id: `${pageId}|1acb1df5-4f62-72c8-ccf1-49c8e1a23f1e`,
          appliesTo: "ELEMENT",
          styleBlockIds: [],
        },
        targets: [
          {
            id: `${pageId}|1acb1df5-4f62-72c8-ccf1-49c8e1a23f1e`,
            appliesTo: "ELEMENT",
            styleBlockIds: [],
          },
        ],
        config: {
          loop: false,
          playInReverse: false,
          scrollOffsetValue: 50,
          scrollOffsetUnit: "%",
          delay: null,
          direction: null,
          effectIn: null,
        },
        createdOn: 1632896084182,
      },
      "e-9": {
        id: "e-9",
        name: "",
        animationType: "preset",
        eventTypeId: "SCROLL_OUT_OF_VIEW",
        action: {
          id: "",
          actionTypeId: "GENERAL_START_ACTION",
          config: {
            delay: 0,
            easing: "",
            duration: 0,
            actionListId: "a-3",
            affectedElements: {},
            playInReverse: false,
            autoStopEventId: "e-206",
          },
        },
        mediaQueries: ["main", "medium", "small", "tiny"],
        target: {
          id: `${pageId}|1acb1df5-4f62-72c8-ccf1-49c8e1a23f13`,
          appliesTo: "ELEMENT",
          styleBlockIds: [],
        },
        targets: [
          {
            id: `${pageId}|1acb1df5-4f62-72c8-ccf1-49c8e1a23f13`,
            appliesTo: "ELEMENT",
            styleBlockIds: [],
          },
        ],
        config: {
          loop: false,
          playInReverse: false,
          scrollOffsetValue: 50,
          scrollOffsetUnit: "%",
          delay: null,
          direction: null,
          effectIn: null,
        },
        createdOn: 1632896085178,
      },
    },
    actionLists: {
      "a-2": {
        id: "a-2",
        title: "Section content timeline [Scroll In]",
        actionItemGroups: [
          {
            actionItems: [
              {
                id: "a-2-n",
                actionTypeId: "STYLE_SIZE",
                config: {
                  delay: 0,
                  easing: "outQuint",
                  duration: 400,
                  target: {
                    useEventTarget: "CHILDREN",
                    selector: ".layout121_progress-bar",
                    selectorGuids: ["45d4c7b7-3d59-141e-ae33-a4f7281e8226"],
                  },
                  widthValue: 0,
                  widthUnit: "%",
                  heightUnit: "PX",
                  locked: false,
                },
              },
            ],
          },
          {
            actionItems: [
              {
                id: "a-2-n-2",
                actionTypeId: "STYLE_SIZE",
                config: {
                  delay: 0,
                  easing: "outQuint",
                  duration: 400,
                  target: {
                    useEventTarget: "CHILDREN",
                    selector: ".layout121_progress-bar",
                    selectorGuids: ["45d4c7b7-3d59-141e-ae33-a4f7281e8226"],
                  },
                  widthValue: 100,
                  widthUnit: "%",
                  heightUnit: "PX",
                  locked: false,
                },
              },
            ],
          },
        ],
        useFirstGroupAsInitialState: true,
        createdOn: 1626765982929,
      },
      a: {
        id: "a",
        title: "Section Content 99 [Timeline Progress]",
        continuousParameterGroups: [
          {
            id: "a-p",
            type: "SCROLL_PROGRESS",
            parameterLabel: "Scroll",
            continuousActionGroups: [
              {
                keyframe: 25,
                actionItems: [
                  {
                    id: "a-n",
                    actionTypeId: "STYLE_SIZE",
                    config: {
                      delay: 0,
                      easing: "",
                      duration: 500,
                      target: {
                        useEventTarget: "CHILDREN",
                        selector: ".layout121_progress-bar",
                        selectorGuids: ["45d4c7b7-3d59-141e-ae33-a4f7281e8226"],
                      },
                      heightValue: 0,
                      widthUnit: "PX",
                      heightUnit: "%",
                      locked: false,
                    },
                  },
                ],
              },
              {
                keyframe: 55,
                actionItems: [
                  {
                    id: "a-n-2",
                    actionTypeId: "STYLE_SIZE",
                    config: {
                      delay: 0,
                      easing: "",
                      duration: 500,
                      target: {
                        useEventTarget: "CHILDREN",
                        selector: ".layout121_progress-bar",
                        selectorGuids: ["45d4c7b7-3d59-141e-ae33-a4f7281e8226"],
                      },
                      heightValue: 100,
                      widthUnit: "PX",
                      heightUnit: "%",
                      locked: false,
                    },
                  },
                ],
              },
            ],
          },
        ],
        createdOn: 1626766527768,
      },
      "a-3": {
        id: "a-3",
        title: "Section content timeline [Scroll Out]",
        actionItemGroups: [
          {
            actionItems: [
              {
                id: "a-3-n",
                actionTypeId: "STYLE_SIZE",
                config: {
                  delay: 0,
                  easing: "outQuint",
                  duration: 400,
                  target: {
                    useEventTarget: "CHILDREN",
                    selector: ".layout121_progress-bar",
                    selectorGuids: ["45d4c7b7-3d59-141e-ae33-a4f7281e8226"],
                  },
                  widthValue: 0,
                  widthUnit: "%",
                  heightUnit: "PX",
                  locked: false,
                },
              },
            ],
          },
        ],
        useFirstGroupAsInitialState: false,
        createdOn: 1626765982929,
      },
    },
    site: {
      mediaQueries: [
        { key: "main", min: 992, max: 10000 },
        {
          key: "medium",
          min: 768,
          max: 991,
        },
        { key: "small", min: 480, max: 767 },
        { key: "tiny", min: 0, max: 479 },
      ],
    },
  };
}

// eslint-disable-next-line import/no-default-export
export default getEvents;
